/** Backend `ResourceEntityCategory` — serialized as these strings. */
export type EntityCategory = 'SEMANTIC' | 'PII';

export interface EntityType {
  /** Backend `ResourceEntityType` value — what `entity/{type}` resolves via `fromValue()`. */
  id: string;
  name: string;
  /**
   * camelCased backend displayName — the Elasticsearch field prefix used in
   * `<field>Entities.lowercase` searches. Same as `id` for every SEMANTIC type
   * (all single words); differs only for the space-separated PII values.
   */
  field: string;
  category: EntityCategory;
}

export const ENTITY_TYPES: EntityType[] = [
  { id: 'location', name: 'Location', field: 'location', category: 'SEMANTIC' },
  { id: 'person', name: 'Person', field: 'person', category: 'SEMANTIC' },
  { id: 'organization', name: 'Organization', field: 'organization', category: 'SEMANTIC' },
  { id: 'time', name: 'Time', field: 'time', category: 'SEMANTIC' },
  { id: 'date', name: 'Date', field: 'date', category: 'SEMANTIC' },
  { id: 'percent', name: 'Percent', field: 'percent', category: 'SEMANTIC' },
  { id: 'money', name: 'Money', field: 'money', category: 'SEMANTIC' },
  { id: 'event', name: 'Event', field: 'event', category: 'SEMANTIC' },
  { id: 'title', name: 'Title', field: 'title', category: 'SEMANTIC' },
  { id: 'misc', name: 'Misc', field: 'misc', category: 'SEMANTIC' },
  { id: 'social security number', name: 'Social Security Number', field: 'socialSecurityNumber', category: 'PII' },
  { id: 'credit card', name: 'Credit Card', field: 'creditCard', category: 'PII' },
  { id: 'email address', name: 'Email Address', field: 'emailAddress', category: 'PII' },
  { id: 'phone', name: 'Phone Number', field: 'phone', category: 'PII' },
].sort((a, b) => a.name.localeCompare(b.name));

/** The only type the aggregate `/postprocessingmetrics` response includes. */
export const DEFAULT_ENTITY_TYPE_ID = 'person';

/**
 * The types the post-processing metrics endpoints can actually aggregate. PII
 * entities are dropped before storage (`NLPQueueConsumer` skips the PII
 * category), so they have no Elasticsearch fields and `entity/{type}` errors
 * for them regardless of `enhancedPiiDetection`.
 */
export const SEMANTIC_ENTITY_TYPES: EntityType[] = ENTITY_TYPES.filter(t => t.category !== 'PII');
